import { render, staticRenderFns } from "./CourseAssessmentMultipleChoices.vue?vue&type=template&id=43ce883e&scoped=true"
import script from "./CourseAssessmentMultipleChoices.vue?vue&type=script&lang=ts"
export * from "./CourseAssessmentMultipleChoices.vue?vue&type=script&lang=ts"
import style0 from "./CourseAssessmentMultipleChoices.vue?vue&type=style&index=0&id=43ce883e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ce883e",
  null
  
)

export default component.exports